import { generateClient } from 'aws-amplify/api';
import Vue from 'vue';
import * as qlqueries from '../graphql/queries';
import * as qlmutations from '../graphql/mutations';

const client = generateClient();
const graphqlOperation = (query, variables) => ({ query, variables });

const state = {
  name: 'Permissions',
  logs: {},
  inputs: null,
  inputProfiles: null,
  providers: null,
  outputs: null,
  outputsById: null,
  outputProfiles: null,
  routers: null,
  multiviewers: null,
  routerGroups: null,
  routerDestinations: null,
  routerSources: null,
  transcoderProfiles: null,
  transcodingProfiles: null,
  transcodingOutputs: null,
  locations: null,
  clients: [],
  claims: null,
  features: null,
  loading: false,
};

const getters = {
};

const mutations = {
  setList: (state, payload) => {
    Vue.set(state, payload.property, payload.data.items);
    const { items } = payload.data;
    const listById = {};
    items.forEach((item) => {
      if (!item.id) {
        console.warn(`Item without ID found in ${payload.property}:`, item);
        return;
      }
      listById[item.id] = item;
    });

    Vue.set(state, `${payload.property}ById`, listById);
  },

  setLoading: (state, payload) => {
    Vue.set(state, 'loading', payload);
  },
};

const actions = {
  async listInputs({ commit }) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlqueries.listInputs,
          {
            limit: 1500,
          }),
      );
      const { data } = result;
      commit('setList', { data: data.listInputs, property: 'inputs' });
      return data.listInputs;
    } catch (error) {
      const hasData = !!error.data && !!error.data.listInputs;
      if (hasData) {
        const { data } = error;
        commit('setList', { data: data.listInputs, property: 'inputs' });
        this._vm.$message.error(
          { message: 'Oops something went wrong. Can\'t get some of the INPUTS' },
        );
        return { error: true, message: error.errors };
      }
      this._vm.$message.error(
        { message: 'Oops something went wrong. Can\'t add inputs' },
      );
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async listInputProfiles({ commit }) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlqueries.listInputProfiles, { limit: 1500 }),
      );
      const { data } = result;
      commit('setList', { data: data.listInputProfiles, property: 'inputProfiles' });
      return data.listInputProfiles;
    } catch (error) {
      this._vm.$message.error({ message: 'Oops something went wrong. Can\'t get input profiles' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async listProviders({ commit }) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlqueries.listProviders, { limit: 1500 }),
      );
      const { data } = result;
      commit('setList', { data: data.listProviders, property: 'providers' });
      return data.listProviders;
    } catch (error) {
      this._vm.$message.error({ message: 'Oops something went wrong. Can\'t get providers' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async createInputProfile({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlmutations.createInputProfile, { input: payload }),
      );
      this._vm.$message({ message: 'Input profile created' });
      return result.data.createInputProfile;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async updateInputProfile({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlmutations.updateInputProfile, { input: payload }),
      );
      this._vm.$message({ message: 'Item updated' });
      return result.data.updateInputProfile;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async deleteInputProfile({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlmutations.deleteInputProfile, { input: payload }),
      );
      this._vm.$message({ message: 'Input profile deleted' });
      return result.data.deleteInputProfile;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async createInputProfileInputMap({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlmutations.createInputProfileInputMap, { input: payload }),
      );
      return result.data.createInputProfileInputMap;
    } catch (error) {
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async deleteInputProfileInputMap({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlmutations.deleteInputProfileInputMap, { input: payload }),
      );
      return result.data.deleteInputProfileInputMap;
    } catch (error) {
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async createProvider({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlmutations.createProvider, { input: payload }),
      );
      this._vm.$message({ message: 'Provider created' });
      return result.data.createProvider;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async updateProvider({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlmutations.updateProvider, { input: payload }),
      );
      this._vm.$message({ message: 'Item updated' });
      return result.data.updateProvider;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async deleteProvider({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlmutations.deleteProvider, { input: payload }),
      );
      this._vm.$message({ message: 'Provider deleted' });
      return result.data.deleteProvider;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async listTranscodingProfiles({ commit }) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlqueries.listTranscodingProfiles, { limit: 1500 })
      );
      const { data } = result;
      commit('setList', { data: data.listTranscodingProfiles, property: 'transcodingProfiles' });
      return data.listTranscodingProfiles;
    } catch (error) {
      console.error(error);
      this._vm.$message.error({ message: 'Error fetching Transcoding Channels' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async listTranscodingOutputs({ commit }) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlqueries.listTranscodingOutputs, { limit: 1500 })
      );
      const { data } = result;
      commit('setList', { data: data.listTranscodingOutputs, property: 'transcodingOutputs' });
      return data.listTranscodingOutputs;
    } catch (error) {
      console.error(error);
      this._vm.$message.error({ message: 'Error fetching Transcoding Outputs' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async listOutputs({ commit }) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlqueries.listOutputs,
          {
            limit: 1500,
          }),
      );
      const { data } = result;
      commit('setList', { data: data.listOutputs, property: 'outputs' });
      return data.listOutputs;
    } catch (error) {
      const hasData = !!error.data && !!error.data.listOutputs;
      if (hasData) {
        const { data } = error;
        commit('setList', { data: data.listOutputs, property: 'outputs' });
        this._vm.$message.error(
          { message: 'Oops something went wrong. Can\'t get some of the OUTPUTS' },
        );
        return { error: true, message: error.errors };
      }
      this._vm.$message.error(
        { message: 'Oops something went wrong. Can\'t add outputs' },
      );
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async listOutputProfiles({ commit }) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlqueries.listOutputProfiles,
          {
            limit: 1500,
          }),
      );
      const { data } = result;
      commit('setList', { data: data.listOutputProfiles, property: 'outputProfiles' });
      return data.listOutputProfiles;
    } catch (error) {
      const hasData = !!error.data && !!error.data.listOutputProfiles;
      if (hasData) {
        const { data } = error;
        commit('setList', { data: data.listOutputProfiles, property: 'outputProfiles' });
        this._vm.$message.error(
          { message: 'Oops something went wrong. Can\'t get some of the output profiles' },
        );
        return { error: true, message: error.errors };
      }
      this._vm.$message.error(
        { message: 'Oops something went wrong. Can\'t add output profiles' },
      );
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async listRouters({ commit }) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlqueries.listRouters,
          {
            limit: 1500,
          }),
      );
      const { data } = result;
      commit('setList', { data: data.listRouters, property: 'routers' });
      return data.listRouters;
    } catch (error) {
      this._vm.$message.error(
        { message: 'Oops something went wrong. Can\'t get routers' },
      );
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async listRouterGroups({ commit }) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlqueries.listRouterGroups,
          {
            limit: 1500,
          }),
      );
      const { data } = result;
      commit('setList', { data: data.listRouterGroups, property: 'routerGroups' });
      return data.listRouterGroups;
    } catch (error) {
      const hasData = !!error.data && !!error.data.listRouterGroups;
      if (hasData) {
        const { data } = error;
        commit('setList', { data: data.listRouterGroups, property: 'routerGroups' });
        this._vm.$message.error(
          { message: 'Oops something went wrong. Can\'t get some of the router groups' },
        );
        return { error: true, message: error.errors };
      }
      this._vm.$message.error(
        { message: 'Oops something went wrong. Can\'t get router groups' },
      );
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async listTranscoderProfiles({ commit }) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlqueries.listTranscoderProfiles,
          {
            limit: 1500,
          }),
      );
      const { data } = result;
      commit('setList', { data: data.listTranscoderProfiles, property: 'transcoderProfiles' });
      return data.listTranscoderProfiles;
    } catch (error) {
      const hasData = !!error.data && !!error.data.listTranscoderProfiles;
      if (hasData) {
        const { data } = error;
        commit('setList', { data: data.listTranscoderProfiles, property: 'transcoderProfiles' });
        this._vm.$message.error(
          { message: 'Oops something went wrong. Can\'t get some of the transcoding channels' },
        );
        return { error: true, message: error.errors };
      }
      this._vm.$message.error(
        { message: 'Oops something went wrong. Can\'t get transcoding channels' },
      );
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async listRouterDestinations({ commit }) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlqueries.listRouterDestinations,
          {
            limit: 2500,
          }),
      );
      const { data } = result;
      commit('setList', { data: data.listRouterDestinations, property: 'routerDestinations' });
      return data.listRouterDestinations;
    } catch (error) {
      const hasData = !!error.data && !!error.data.listRouterDestinations;
      if (hasData) {
        const { data } = error;
        commit('setList', { data: data.listRouterDestinations, property: 'routerDestinations' });
        this._vm.$message.error(
          { message: 'Oops something went wrong. Can\'t get some of the destinations' },
        );
        return { error: true, message: error.errors };
      }
      this._vm.$message.error(
        { message: 'Oops something went wrong. Can\'t get destinations' },
      );
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async listRouterSources({ commit }) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlqueries.listRouterSources,
          {
            limit: 1500,
          }),
      );
      const { data } = result;
      commit('setList', { data: data.listRouterSources, property: 'routerSources' });
      return data.listRouterSources;
    } catch (error) {
      console.log('error', error.data);
      const hasData = !!error.data && !!error.data.listRouterSources;
      if (hasData) {
        const { data } = error;
        commit('setList', { data: data.listRouterSources, property: 'routerSources' });
        this._vm.$message.error(
          { message: 'Oops something went wrong. Can\'t get some of the sources' },
        );
        return { error: true, message: error.errors };
      }
      this._vm.$message.error(
        { message: 'Oops something went wrong. Can\'t get sources' },
      );
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async listClients({ commit }) {
    const result = await client.graphql(
      graphqlOperation(qlqueries.listClients, {
        limit: 1500,
      }),
    );
    const { data } = result;
    const isFailure = !!result.errors;
    if (isFailure) return { error: true, message: result.errors };
    commit('setList', { data: data.listClients, property: 'clients' });
    return data.listClients.items;
  },

  async listClaims({ commit }) {
    const result = await client.graphql(
      graphqlOperation(qlqueries.listClaims, {
        limit: 250,
      }),
    );
    const { data } = result;
    const isFailure = !!result.errors;
    if (isFailure) return { error: true, message: result.errors };
    commit('setList', { data: data.listClaims, property: 'claims' });
    return data.listClaims;
  },

  async listFeatures({ commit }) {
    const result = await client.graphql(
      graphqlOperation(qlqueries.listFeatures, {
        limit: 250,
      }),
    );
    const { data } = result;
    const isFailure = !!result.errors;
    if (isFailure) return { error: true, message: result.errors };
    commit('setList', { data: data.listFeatures, property: 'features' });

    return data.listFeatures;
  },

  async updateInput({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.updateInput,
          { input: payload },
        ),
      );
      const { data } = result;
      commit('update', { data: data.updateInput, property: 'input' });
      this._vm.$message({ message: 'Item updated' });
      return data.updateInput;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async updateOutput({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.updateOutput,
          { input: payload },
        ),
      );
      const { data } = result;
      commit('update', { data: data.updateOutput, property: 'input' });
      this._vm.$message({ message: 'Item updated' });
      return data.updateOutput;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async updateRouter({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.updateRouter,
          { input: payload },
        ),
      );
      const { data } = result;
      commit('update', { data: data.updateRouter, property: 'router' });
      this._vm.$message({ message: 'Item updated' });
      return data.updateRouter;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async updateRouterGroup({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.updateRouterGroup,
          { input: payload },
        ),
      );
      const { data } = result;
      commit('update', { data: data.updateRouterGroup, property: 'router' });
      this._vm.$message({ message: 'Item updated' });
      return data.updateRouterGroup;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async updateRouterSource({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.updateRouterSource,
          { input: payload },
        ),
      );
      const { data } = result;
      commit('update', { data: data.updateRouterSource, property: 'router' });
      this._vm.$message({ message: 'Item updated' });
      return data.updateRouterSource;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async updateRouterDestination({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.updateRouterDestination,
          { input: payload },
        ),
      );
      const { data } = result;
      commit('update', { data: data.updateRouterDestination, property: 'router' });
      this._vm.$message({ message: 'Item updated' });
      return data.updateRouterDestination;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async updateOutputProfile({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.updateOutputProfile,
          { input: payload },
        ),
      );
      const { data } = result;
      commit('update', { data: data.updateOutputProfile, property: 'input' });
      this._vm.$message({ message: 'Item updated' });
      return data.updateOutputProfile;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async deleteOutput({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.deleteOutput,
          { input: payload },
        ),
      );
      const { data } = result;
      this._vm.$message({ message: 'Output deleted' });
      return data.deleteOutput;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async deleteOutputProfile({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.deleteOutputProfile,
          { input: payload },
        ),
      );
      const { data } = result;
      this._vm.$message({ message: 'Output profile deleted' });
      return data.deleteOutputProfile;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async deleteInput({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.deleteInput,
          { input: payload },
        ),
      );
      const { data } = result;
      this._vm.$message({ message: 'Input deleted' });
      return data.deleteInput;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async deleteRouter({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.deleteRouter,
          { input: payload },
        ),
      );
      const { data } = result;
      this._vm.$message({ message: 'Router deleted' });
      return data.deleteRouter;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async deleteRouterGroup({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.deleteRouterGroup,
          { input: payload },
        ),
      );
      const { data } = result;
      this._vm.$message({ message: 'Router deleted' });
      return data.deleteRouterGroup;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async deleteRouterDestination({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.deleteRouterDestination,
          { input: payload },
        ),
      );
      const { data } = result;
      this._vm.$message({ message: 'Router destination deleted' });
      return data.deleteRouterDestination;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async deleteRouterSource({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.deleteRouterSource,
          { input: payload },
        ),
      );
      const { data } = result;
      this._vm.$message({ message: 'Router source deleted' });
      return data.deleteRouterSource;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },
  async deleteTranscoderProfile({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.deleteTranscoderProfile,
          { input: payload },
        ),
      );
      const { data } = result;
      this._vm.$message({ message: 'Transcoder profile deleted' });
      return data.deleteTranscoderProfile;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async deleteTranscodingProfile({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlmutations.deleteTranscodingProfile, { input: { id: payload.id } })
      );
      const { data } = result;
      this._vm.$message({ message: 'transcoding Channel deleted' });
      return data.deleteTranscodingProfile;
    } catch (error) {
      this._vm.$message.error({ message: 'Error deleting transcoding Channel' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async deleteTranscodingOutput({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlmutations.deleteTranscodingOutput, { input: { id: payload.id } })
      );
      const { data } = result;
      this._vm.$message({ message: 'Transcoding Output deleted' });
      return data.deleteTranscodingOutput;
    } catch (error) {
      this._vm.$message.error({ message: 'Error deleting Transcoding Output' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async updateTranscoderProfile({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.updateTranscoderProfile,
          { input: payload },
        ),
      );
      const { data } = result;
      commit('update', { data: data.updateTranscoderProfile, property: 'transocedProfile' });
      this._vm.$message({ message: 'Item updated' });
      return data.updateTranscoderProfile;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async updateTranscodingProfile({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlmutations.patchTranscodingProfile, payload)
      );
      const { data } = result;
      const response = data.patchTranscodingProfile;
      if (response?.success === false) {
        return response;
      }
      this._vm.$message({ message: 'transcoding Channel updated' });
      return response;
    } catch (error) {
      this._vm.$message.error({ message: 'Error updating transcoding Channel' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async updateTranscodingOutput({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlmutations.patchTranscodingOutput, payload)
      );
      const { data } = result;
      const response = data.patchTranscodingOutput;
      if (response?.success === false) {
        return response;
      }
      this._vm.$message({ message: 'Transcoding Output updated' });
      return response;
    } catch (error) {
      this._vm.$message.error({ message: 'Error updating Transcoding Output' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },
  // delete mutations
  async createInput({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.createInput,
          { input: payload },
        ),
      );
      const { data } = result;
      this._vm.$message({ message: 'Input created' });
      return data.createInput;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async createTranscoderProfile({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.createTranscoderProfile,
          { input: payload },
        ),
      );
      const { data } = result;
      this._vm.$message({ message: 'Transcoder profile created' });
      return data.createTranscoderProfile;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async createTranscodingProfile({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlmutations.addTranscodingProfile, payload)
      );
      const { data } = result;
      const response = data.addTranscodingProfile;
      if (response?.success === false) {
        return response;
      }
      this._vm.$message({ message: 'transcoding Channel created' });
      return response;
    } catch (error) {
      this._vm.$message.error({ message: 'Error creating transcoding Channel' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async createTranscodingOutput({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlmutations.addTranscodingOutput, payload)
      );
      const { data } = result;
      const response = data.addTranscodingOutput;
      if (response?.success === false) {
        return response;
      }
      this._vm.$message({ message: 'Transcoding Output created' });
      return response;
    } catch (error) {
      this._vm.$message.error({ message: 'Error creating Transcoding Output' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async createOutput({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.createOutput,
          { input: payload },
        ),
      );
      const { data } = result;
      this._vm.$message({ message: 'Output created' });
      return data.createOutput;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async createOutputProfile({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.createOutputProfile,
          { input: payload },
        ),
      );
      const { data } = result;
      this._vm.$message({ message: 'Profile created' });
      return data.createOutputProfile;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async createRouter({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.createRouter,
          { input: payload },
        ),
      );
      const { data } = result;
      this._vm.$message({ message: 'Route created' });
      return data.createRouter;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async createRouterGroup({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.createRouterGroup,
          { input: payload },
        ),
      );
      const { data } = result;
      this._vm.$message({ message: 'Router Group created' });
      return data.createRouterGroup;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async createRouterDestination({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.createRouterDestination,
          { input: payload },
        ),
      );
      const { data } = result;
      this._vm.$message({ message: 'Router Group Destination created' });
      return data.createRouterDestination;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async createRouterSource({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.createRouterSource,
          { input: payload },
        ),
      );
      const { data } = result;
      this._vm.$message({ message: 'Router Group Destination created' });
      return data.createRouterSource;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async createOutputProfileOutputMap({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.createOutputProfileOutputMap,
          { input: payload },
        ),
      );
      const { data } = result;
      return data.createOutputProfileOutputMap;
    } catch (error) {
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },
  async deleteOutputProfileOutputMap({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.deleteOutputProfileOutputMap,
          { input: payload },
        ),
      );
      const { data } = result;
      return data.deleteOutputProfileOutputMap;
    } catch (error) {
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async createOutputAccountMap({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.createOutputAccountMap,
          { input: payload },
        ),
      );
      const { data } = result;
      return data.createOutputAccountMap;
    } catch (error) {
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async deleteOutputAccountMap({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.deleteOutputAccountMap,
          { input: payload },
        ),
      );
      const { data } = result;
      return data.deleteOutputAccountMap;
    } catch (error) {
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async deleteOutputEquipmentMap({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.deleteOutputEquipmentMap,
          { input: payload },
        ),
      );
      const { data } = result;
      return data.deleteOutputEquipmentMap;
    } catch (error) {
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async deleteEventOutputMap({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.deleteEventOutputMap,
          { input: payload },
        ),
      );
      const { data } = result;
      return data.deleteEventOutputMap;
    } catch (error) {
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async createInputAccountMap({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.createInputAccountMap,
          { input: payload },
        ),
      );
      const { data } = result;
      return data.createInputAccountMap;
    } catch (error) {
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async deleteInputAccountMap({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.deleteInputAccountMap,
          { input: payload },
        ),
      );
      const { data } = result;
      return data.deleteInputAccountMap;
    } catch (error) {
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async deleteInputEquipmentMap({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.deleteInputEquipmentMap,
          { input: payload },
        ),
      );
      const { data } = result;
      return data.deleteInputEquipmentMap;
    } catch (error) {
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  // DEST -> Router Group
  async createRouterDestinationGroupMap({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.createRouterDestinationGroupMap,
          { input: payload },
        ),
      );
      const { data } = result;
      return data.createRouterDestinationGroupMap;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },
  async deleteRouterDestinationGroupMap({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.deleteRouterDestinationGroupMap,
          { input: payload },
        ),
      );
      const { data } = result;
      return data.deleteRouterDestinationGroupMap;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  // SOURCE -> Router Group
  async createRouterSourceGroupMap({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.createRouterSourceGroupMap,
          { input: payload },
        ),
      );
      const { data } = result;
      return data.createRouterSourceGroupMap;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },
  async deleteRouterSourceGroupMap({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.deleteRouterSourceGroupMap,
          { input: payload },
        ),
      );
      const { data } = result;
      return data.deleteRouterSourceGroupMap;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  // OUTPUT -> Router DEST
  async createOutputRouterDestinationMap({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.createOutputRouterDestinationMap,
          { input: payload },
        ),
      );
      const { data } = result;
      return data.createOutputRouterDestinationMap;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },
  async deleteOutputRouterDestinationMap({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.deleteOutputRouterDestinationMap,
          { input: payload },
        ),
      );
      const { data } = result;
      return data.deleteOutputRouterDestinationMap;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  // INPUT -> Router SOURCE
  async createInputRouterSourceMap({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.createInputRouterSourceMap,
          { input: payload },
        ),
      );
      const { data } = result;
      return data.createInputRouterSourceMap;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },
  async deleteInputRouterSourceMap({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.deleteInputRouterSourceMap,
          { input: payload },
        ),
      );
      const { data } = result;
      return data.deleteInputRouterSourceMap;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  // MULTIVIEWER
  async createMultiviewer({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.createMultiviewer,
          { input: payload },
        ),
      );
      const { data } = result;
      this._vm.$message({ message: 'Multiviewer created' });
      return data.createMultiviewer;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },
  async deleteMultiviewer({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.deleteMultiviewer,
          { input: payload },
        ),
      );
      const { data } = result;
      this._vm.$message({ message: 'Multiviewer deleted' });
      return data.deleteMultiviewer;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },
  async updateMultiviewer({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.updateMultiviewer,
          { input: payload },
        ),
      );
      const { data } = result;
      commit('update', { data: data.updateMultiviewer, property: 'multiviewer' });
      this._vm.$message({ message: 'Item updated' });
      return data.updateMultiviewer;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },
  async listMultiviewers({ commit }) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlqueries.listMultiviewers,
          {
            limit: 1500,
          }),
      );
      const { data } = result;
      commit('setList', { data: data.listMultiviewers, property: 'multiviewers' });
      return data.listMultiviewers;
    } catch (error) {
      this._vm.$message.error(
        { message: 'Oops something went wrong. Can\'t get multiviewers' },
      );
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  // Stream Source -> Multiviewer
  async createStreamSourceMultiviewerMap({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.createStreamSourceMultiviewerMap,
          { input: payload },
        ),
      );
      const { data } = result;
      return data.createStreamSourceMultiviewerMap;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },
  async deleteStreamSourceMultiviewerMap({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.deleteStreamSourceMultiviewerMap,
          { input: payload },
        ),
      );
      const { data } = result;
      return data.deleteStreamSourceMultiviewerMap;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },
  async updateStreamSourceMultiviewerMap({ commit }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(
          qlmutations.updateStreamSourceMultiviewerMap,
          { input: payload },
        ),
      );
      const { data } = result;
      return data.updateStreamSourceMultiviewerMap;
    } catch (error) {
      this._vm.$message.error({ message: 'Something went wrong' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },
  async listLocationss({ commit }) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlqueries.listLocationss,
          {
            limit: 1500,
          }),
      );
      const { data } = result;

      // Filter out null items
      const filteredData = {
        ...data.listLocationss,
        items: data.listLocationss.items.filter(item => item !== null)
      };

      commit('setList', { data: filteredData, property: 'locations' });
      return data.listLocationss;
    } catch (error) {
      const hasData = !!error.data && !!error.data.listLocationss;
      if (hasData) {
        const { data } = error;
        // Filter out null items from error data as well
        const filteredData = {
          ...data.listLocationss,
          items: data.listLocationss.items.filter(item => item !== null)
        };
        commit('setList', { data: filteredData, property: 'locations' });
        this._vm.$message.error(
          { message: 'Oops something went wrong. Can\'t get some of the locations' },
        );
        return { error: true, message: error.errors };
      }
      this._vm.$message.error(
        { message: 'Oops something went wrong. Can\'t get locations' },
      );
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async addLocation({ commit, dispatch }, payload) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlmutations.addLocation, { input: payload }),
      );
      const { data } = result;
      const response = data.addLocation;

      if (response?.success === false) {
        return { error: true, message: response?.message || 'Failed to add location' };
      }

      await dispatch('listLocationss');
      this._vm.$message({ message: 'Location created' });
      return response;
    } catch (error) {
      this._vm.$message.error({ message: 'Error creating location' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },

  async removeLocation({ commit, dispatch }, id) {
    commit('setLoading', true);
    try {
      const result = await client.graphql(
        graphqlOperation(qlmutations.removeLocation, { id }),
      );
      const { data } = result;
      const response = data.removeLocation;

      if (response?.success === false) {
        return { error: true, message: response?.message || 'Failed to remove location' };
      }

      await dispatch('listLocationss');
      this._vm.$message({ message: 'Location removed' });
      return response;
    } catch (error) {
      this._vm.$message.error({ message: 'Error removing location' });
      return { error: true, message: error.errors };
    } finally {
      commit('setLoading', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
